import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { i18n } from './i18n'
import { head } from './plugins/head'
import './styles/reset.css'
import './styles/global.css'
import 'leaflet/dist/leaflet.css';

const isDebugEnabled =
  process.env.NODE_ENV !== 'production' || process.env.VUE_APP_DEBUG_LOGS === 'true';

if (!isDebugEnabled && typeof window !== 'undefined' && window.console) {
  // Keep production console noise low while preserving warnings/errors.
  const noop = () => { };
  window.console.log = noop;
  window.console.info = noop;
  window.console.debug = noop;
}

const app = createApp(App)

app
  .use(head)
  .use(router)
  .use(i18n)
  .mount('#app')
